import { IconSVG } from '../types';

export const PlayCircle = ({ size, style }: IconSVG) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 40 40"
      style={style}
    >
      <path
        fill="currentColor"
        d="M17.75 26.25l8.125-5.208c.389-.25.583-.598.583-1.042 0-.445-.194-.792-.583-1.042L17.75 13.75c-.417-.278-.84-.299-1.27-.063-.431.237-.647.605-.647 1.105v10.416c0 .5.216.868.646 1.104.43.236.854.216 1.271-.062zM20 36.667c-2.305 0-4.472-.438-6.5-1.313-2.028-.875-3.792-2.062-5.292-3.562S5.521 28.528 4.646 26.5 3.333 22.305 3.333 20c0-2.306.438-4.472 1.313-6.5.875-2.028 2.062-3.792 3.562-5.292s3.264-2.687 5.292-3.562 4.195-1.313 6.5-1.313c2.306 0 4.472.438 6.5 1.313 2.028.875 3.792 2.062 5.292 3.562s2.687 3.264 3.562 5.292 1.313 4.194 1.313 6.5c0 2.305-.438 4.472-1.313 6.5-.875 2.028-2.062 3.792-3.562 5.292s-3.264 2.687-5.292 3.562-4.194 1.313-6.5 1.313zm0-3.334c3.722 0 6.875-1.291 9.458-3.875 2.584-2.583 3.875-5.736 3.875-9.458 0-3.722-1.291-6.875-3.875-9.458C26.875 7.958 23.722 6.667 20 6.667c-3.722 0-6.875 1.291-9.458 3.875C7.958 13.125 6.667 16.278 6.667 20c0 3.722 1.291 6.875 3.875 9.458 2.583 2.584 5.736 3.875 9.458 3.875z"
      />
    </svg>
  );
};
